module.exports = __webpack_public_path__ + "img/Ic_Pre-Construction.ddc1c12e.svg";